/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { getImageUrlhttps } from "../../utils";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { Col } from "react-bootstrap";
import PlaceHolderImg from "../../assets/images/PlaceholderImage.png";
import ReactTooltip from "react-tooltip";
import UpdateDateMacrosInString from "../UI/UpdateDateMacrosInString";
import { Badge } from "react-bootstrap";
import { getCouponUrlAction } from "../../redux/couponUrl/actions";
import { useHistory } from "react-router";

import Macro from "../../utils/ReplaceMacro";
import { getCouponsStoreByIdAction } from "../../redux/actions";

const CoupensTabCard = ({ coupon }) => {
  let dispatch = useDispatch();
  const history = useHistory();

  const { domainData } = useSelector((state) => state.Website);
  const { selectedStore } = useSelector((state) => state.Stores);
  const { link } = useSelector((state) => state.CouponUrl);
  const [copyText, setCopyText] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newTab, setNewTab] = useState(false);

  const [second, setSecond] = useState(false);

  const [couponImage, setCouponImage] = useState("");

  const countDownTimer = (expDate) => {
    // Get today's date and time
    let now = new Date().getTime();
    let distance = new Date(expDate).getTime() - now;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    if (distance < 0) {
      return <span style={{ fontWeight: 500 }}>Expired</span>;
    } else {
      return (
        <span style={{ margin: 0 }}>
          {" "}
          <i className="ti-timer"></i> {days} <b>d</b> {hours} <b>hr</b>{" "}
          {minutes} <b>min</b>
        </span>
      );
    }
  };

  const handleRedirect = (e) => {
    e.stopPropagation();
    e.preventDefault();
    handleRedirectionLogic();
  };

  const handleRedirectionLogic = () => {
    function withReferLogic() {
      history.push(
        `/couponzr/store/${selectedStore.slug.replace(
          " ",
          ""
        )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`
      );

      window.open(coupon?.finalLink);
      return;
    }

    if (coupon.redirection_type && coupon.redirection_type !== "") {
      if (coupon?.redirection_type === "zero-redirect-with-refer") {
        // return withReferLogic();
        setRedirect2(true);
        return;
      } else if (
        coupon?.redirection_type === "zero-redirect-with-refer" &&
        !(
          selectedStore?.v2_store?.[0]?.affiliate_network
            ?.desktop_redirection_type === "zero-redirect-with-refer"
        )
      ) {
        return withReferLogic();
      } else if (coupon?.redirection_type === "zero-redirect-without-refer") {
        setRedirect(true);
      } else {
        setLoading(false);
        localStorage.setItem("redirection_type", coupon?.redirection_type);
        localStorage.setItem(
          "redirection_type_store",
          selectedStore?.v2_store[0]?.affiliate_network
            ?.desktop_redirection_type
        );

        window.open(
          `/couponsredirect/store/${selectedStore.slug.replace(
            " ",
            ""
          )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`,
          "_blank"
        );
      }
    } else {
      if (
        selectedStore?.v2_store?.[0]?.affiliate_network
          ?.desktop_redirection_type === "zero-redirect-with-refer"
      ) {
        setRedirect2(true);
        return;
      }
      setLoading(true);
      // dispatch(getCouponUrlAction({ finalLink: coupon?.finalLink }));
      localStorage.setItem("finalLink", coupon.finalLink);

      if (coupon?.finalLink) {
        setSecond(true); //to run useEffect even when link has not changed
      }
      if (
        selectedStore?.v2_store[0]?.affiliate_network
          ?.desktop_redirection_type === "zero-redirect-without-refer"
      ) {
        setRedirect(true);
      } else if (
        selectedStore?.v2_store[0]?.affiliate_network
          ?.desktop_redirection_type === "zero-redirect-with-refer"
      ) {
        setRedirect2(true);
      } else if (coupon?.redirection_type === "zero-redirect-without-refer") {
        setRedirect(true);
      } else if (coupon?.redirection_type === "zero-redirect-with-refer") {
        setRedirect2(true);
      } else {
        // setLoading(false);
        localStorage.setItem("redirection_type", coupon?.redirection_type);
        localStorage.setItem(
          "redirection_type_store",
          selectedStore?.v2_store[0]?.affiliate_network
            ?.desktop_redirection_type
        );

        window.open(
          `/couponsredirect/store/${selectedStore.slug.replace(
            " ",
            ""
          )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`,
          "_blank"
        );
      }
    }
  };

  useEffect(() => {
    localStorage.setItem("link", coupon?.finalLink);

    if (redirect) {
      setLoading(false);
      setNewTab(!newTab);
    }
    if (redirect2) {
      setLoading(false);
      setNewTab(!newTab);
    }
  }, [link, newTab, redirect, redirect2, second]);

  useEffect(() => {
    if (coupon?.finalLink && redirect) {
      setRedirect(false);

      window.open(`/mr/`, "_blank");
    }
    if (coupon?.finalLink && redirect2) {
      history.push(
        `/couponzr/store/${selectedStore.slug.replace(
          " ",
          ""
        )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`
      );
      setRedirect2(false);
      window.open(coupon?.finalLink, "_blank");
    }
  }, [link, newTab, redirect, redirect2]);

  useEffect(() => {
    setCouponImage(
      coupon.image !== undefined && coupon.image !== null && coupon.image !== ""
        ? coupon.image
        : selectedStore.image !== undefined &&
          selectedStore.image !== null &&
          selectedStore.image !== ""
        ? selectedStore.image
        : ""
    );
  }, [coupon.image, selectedStore]);

  const copyMethod = (url) => {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const copyUrl = protocol + "//" + domain + url;
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = copyUrl;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
  };

  return (
    <>
      <div className="col-xs-12 col-sm-12" key={coupon._id}>
        <div className="deal-entry" style={{ border: "1px solid #E5E5E5" }}>
          <div
            className="title"
            style={{ cursor: "pointer", borderBottom: "1px dashed #E5E5E5" }}
          >
            <div
              style={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                position: "relative",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <p
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: "700",
                  textShadow: "none",
                }}
              >
                <UpdateDateMacrosInString input={coupon?.title} />
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1rem",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Col md={2} xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <a href={coupon?.link} target="_blank" rel="noreferrer">
                  <img
                    src={getImageUrlhttps(couponImage, PlaceHolderImg)}
                    className="storeCouponCardImg"
                    onError={() => {
                      setCouponImage("");
                    }}
                  />
                </a>
              </div>
            </Col>
            <Col md={8} xs={12}>
              <div>
                {coupon.description && (
                  <div className="entry-content">
                    <p style={{ fontSize: "18px", margin: "0" }}>
                      {coupon.description.length > 120 ? (
                        <Macro
                          input={coupon.description.substring(0, 120) + "..."}
                        />
                      ) : (
                        <Macro input={coupon.description} />
                      )}
                    </p>
                  </div>
                )}
              </div>
            </Col>
            <Col md={2} xs={12}>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Badge
                  bg="inf"
                  style={{
                    fontSize: ".8rem",
                    fontWeight: "200",
                    backgroundColor: domainData?.header_color,
                    color: "white",
                    marginRight: "2px",
                  }}
                >
                  <i title="Verified" className=" ti-thumb-up"></i>
                </Badge>
                {coupon?.tags &&
                  coupon.tags.split(",").map((tag, index) => {
                    return (
                      <Badge
                        bg="inf"
                        style={{
                          fontSize: ".8rem",
                          backgroundColor: domainData?.header_color,
                          color: "white",
                          marginRight: "2px",
                        }}
                      >
                        {tag}
                      </Badge>
                    );
                  })}
              </span>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  className="coupon-code btn"
                  style={{ margin: "0.5rem", float: "right" }}
                  onClick={handleRedirect}
                >
                  <span className="code-text" rel="nofollow">
                    {coupon?.coupon_code
                      ? coupon.coupon_code.substring(
                          coupon.coupon_code.length - 4
                        )
                      : "XXXX"}
                  </span>{" "}
                  <span className="get-code">
                    {loading ? (
                      <div id="loader-background">
                        <div className="loader"></div>
                      </div>
                    ) : coupon.coupon_code ? (
                      "Show Code"
                    ) : (
                      " Visit Offer "
                    )}
                  </span>
                </div>
              </div>
            </Col>
          </div>
          <div style={{ borderBottom: "1px dashed #E5E5E5" }}></div>
          <div className="storeCouponCard">
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <span
                style={{
                  margin: "10px",
                  alignItems: "left",
                  padding: "5px",
                  fontSize: "12px",
                  display:coupon.expiry_date ? "block" :"none"
                }}
              >            
             { coupon.expiry_date &&  <> Expiry : {dayjs(coupon?.expiry_date).format("DD MMM YYYY")} </> }
                <span style={{ marginLeft: "1rem" }}>
                  {countDownTimer(coupon.expiry_date)}
                </span>
              </span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  margin: "3px 20px",
                 
                }}
              >
                <span
                  style={{
                    fontSize: "10px",
                    width: "70px",
                    border: "1px dashed",
                    borderRadius: "5px",
                    padding: "1px 3px",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                  data-tip="Copy"
                  data-event-off="click"
                  onClick={() => {
                    ReactTooltip.hide();
                    setCopyText(true);
                    setTimeout(() => {
                      setCopyText(false);
                    }, 2000);
                    localStorage.setItem("finalLink", coupon?.finalLink);
                    // copyMethod(`/store/${selectedStore.slug}/coupon/${selectedStore.slug}/${coupon?._id}`)
                    if (
                      coupon?.redirection_type === "zero-redirect-without-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zdwor`
                      );
                    } else if (
                      coupon?.redirection_type === "zero-redirect-with-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zrwr`
                      );
                    } else if (coupon?.redirection_type === "Meta") {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/mtrd`
                      );
                    } else if (coupon?.redirection_type === "S2S") {
                      // copyMethod(
                      //   `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/s2s`
                      // );
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/s2s`
                      );
                    } else if (coupon?.redirection_type === "redirection") {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }`
                      );
                    } else if (
                      selectedStore?.v2_store[0]?.affiliate_network
                        ?.desktop_redirection_type ===
                      "zero-redirect-without-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zdwor`
                      );
                    } else if (
                      selectedStore?.v2_store[0]?.affiliate_network
                        ?.desktop_redirection_type ===
                      "zero-redirect-with-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zrwr`
                      );
                    } else if (
                      selectedStore?.v2_store?.[0]?.affiliate_network
                        ?.desktop_redirection_type === "Meta"
                    ) {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/mtrd`
                      );
                    } else if (
                      selectedStore?.v2_store?.[0]?.affiliate_network
                        ?.desktop_redirection_type === "S2S"
                    ) {
                      // copyMethod(
                      //   `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/s2s`
                      // );
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/s2s`
                      );
                    } else {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }`
                      );
                    }
                  }}
                >
                  Share Offer
                </span>

                {copyText && (
                  <span
                    style={{
                      fontSize: "10px",
                      padding: "1px 8px 1px 0px",
                      margin: "0 10px",
                      color: "#4E944F",
                      borderRadius: "5px",
                      border: "1px solid #4E944F",
                      fontWeight: "bold",
                    }}
                  >
                    <span
                      className="ti-check"
                      style={{ padding: "2px", color: "#4E944F" }}
                    ></span>
                    Copied
                  </span>
                )}
                <ReactTooltip className="customTooltipclass" />
              </div>
            </div>
          </div>
        </div>
        {/* */}
      </div>
    </>
  );
};

export default CoupensTabCard;
